import './ProjectBuilder.css';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import Alert from 'common/components/Alert';
import UnderConstruction from 'common/components/UnderConstruction';
import PassportShare from 'components/PassportShare';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import CandidateOnboarding from './components/CandidateOnboarding';
import ForgotPassword from './components/ForgotPassword';

const App = () => {
  return (
    <div className="App">
      <CssBaseline />
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/signup/candidate/:candidateId" component={Signup} />
        <Route path="/signup" component={Signup} />
        <Route path="/candidate-onboarding" component={CandidateOnboarding} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/passport-share/:shareHash" component={PassportShare} />
        <Route path="/" component={Dashboard} />
      </Switch>
      <Alert />
      <UnderConstruction />
    </div>
  );
};

export default App;
